export default __webpack_public_path__ + "static/integrated-panel-a887e53f15f227d2d713b1fd7357934d.gif";